import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DateRangeInterface } from '@app/shared/components/date-picker/interfaces/date-picker.interface';
import * as moment from 'moment';
import { Moment } from 'moment';

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent {
  @Input() set dateRange(range: DateRangeInterface) {
    this.selected = {
      startDate: moment(range.start),
      endDate: moment(range.end),
    }
  }
  @Input() ranges: { [key: string]: Moment[] } = {
    'This Week': [moment().startOf('week'), moment().subtract(1, 'day')],
    'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
    'This Month': [moment().startOf('month'), moment().startOf('month')],
    'Last 30 Days': [moment().subtract(30, 'days'), moment().subtract(1, 'days')],
    'Last Month': [moment().startOf('month'), moment().endOf('month')],
    'Rolling 12 Months': [moment(), moment()],
  }
  @Output() dateChange: EventEmitter<DateRangeInterface> = new EventEmitter<DateRangeInterface>();
  public today = new Date();

  public selected: {
    startDate: Moment;
    endDate: Moment;
  };
  public alwaysShowCalendars: boolean;
  public invalidDates: moment.Moment[] = [moment().add(2, 'days'), moment().add(3, 'days'), moment().add(5, 'days')];

  public isInvalidDate = (m: moment.Moment) =>  {
    return this.invalidDates.some(d => d.isSame(m, 'day') )
  }

  constructor() {
    this.alwaysShowCalendars = true;
  }

  public onChangeDateRange(): void {
    this.dateChange.emit({
      start: moment(this.selected.startDate).format('YYYY-MM-DD'),
      end: moment(this.selected.endDate).format('YYYY-MM-DD'),
    });
  }
}
